/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const onboardingPatchInputDataRecruitingVolumeSchema = z.enum(['low', 'mid', 'high', 'unknown'])

export type OnboardingPatchInputDataRecruitingVolumeSchema = z.infer<
	typeof onboardingPatchInputDataRecruitingVolumeSchema
>
